import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from './components'
import common from './common'

import utils from './common/utils/index.js'
Vue.prototype.utils = utils

import ElementUI from 'element-ui';
import '@/style/common.scss'
import '@/assets/iconfont/iconfont.css'
import '@/style/element-variables.scss';

import VueAMap from 'vue-amap' //高德地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // 高德key
  key: "5e57f1eaf86b6199201f87e7b70ec1cc", //  申请好的Web端开发者Key
  // 插件集合 （插件按需引入）
  plugins: ["AMap.AutoComplete", "AMap.PlaceSearch", "AMap.Driving", "AMap.DragRoute"],
  v: "2.0", // 版本
  uiVersion: "1.1.11", // ui版本号
});

import VueKinesis from 'vue-kinesis' //动画
import { KinesisContainer, KinesisElement } from "vue-kinesis";
Vue.use(VueKinesis)
Vue.use(KinesisContainer)
Vue.use(KinesisElement)

//size 用于改变组件的默认尺寸，zIndex 设置弹框的初始 z-index（默认值：2000）
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(components)
Vue.use(common)

Vue.config.productionTip = false

let app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')